import { render, staticRenderFns } from "./SliderNew.vue?vue&type=template&id=287a644b&scoped=true"
import script from "./SliderNew.vue?vue&type=script&lang=ts"
export * from "./SliderNew.vue?vue&type=script&lang=ts"
import style0 from "./SliderNew.vue?vue&type=style&index=0&id=287a644b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287a644b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287a644b')) {
      api.createRecord('287a644b', component.options)
    } else {
      api.reload('287a644b', component.options)
    }
    module.hot.accept("./SliderNew.vue?vue&type=template&id=287a644b&scoped=true", function () {
      api.rerender('287a644b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SliderNew.vue"
export default component.exports